import * as React from 'react'
import COLORS from '../../styles/colors'
import { SVGProps } from '../../types/svg'

const defaultSize = {
  width: 40,
  height: 38,
}

function SvgComponent({ style, color = COLORS.brand.primaryDark }: SVGProps) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 40 38'>
      <defs>
        <style>{`".prefix__a{fill:${color}}"`}</style>
      </defs>
      <path
        className='prefix__a'
        d='M31.017 5.746h.053a.656.656 0 00.091-.007 1.466 1.466 0 011.436 1.463.656.656 0 101.312 0 2.781 2.781 0 00-2.182-2.712v-.63a.656.656 0 10-1.312 0v.66a2.777 2.777 0 00.717 5.459 1.465 1.465 0 11-1.465 1.465.656.656 0 10-1.312 0 2.781 2.781 0 002.059 2.682v.719a.656.656 0 101.312 0v-.689a2.777 2.777 0 00-.594-5.489 1.465 1.465 0 01-.115-2.925zm0 0'
      />
      <path
        className='prefix__a'
        d='M31.169 0A9.41 9.41 0 0022.4 6.158H6.124a.686.686 0 00-.656.685L5.313 29.85H.673a.645.645 0 00-.673.626v2.92a5.152 5.152 0 004.919 5.131v.014h20.249v-.019c.164.006.232.019.335.019h.014a5.151 5.151 0 005.143-5.151V18.627c.164.009.338.014.507.014a9.32 9.32 0 000-18.641zm-26 37.228a3.858 3.858 0 01-3.852-3.84v-2.226h19.014v2.217a5.145 5.145 0 001.519 3.646c.069.069.154.122.226.2zm24.181-3.84a3.84 3.84 0 01-3.832 3.84H25.5a3.868 3.868 0 01-3.861-3.849v-2.9a.605.605 0 00-.626-.625H6.624L6.775 7.47h15.262a9.854 9.854 0 00-.18 1.821 9.248 9.248 0 00.792 3.753h-6.194a.656.656 0 000 1.312h6.906a9.255 9.255 0 005.988 4.107zm1.819-16.058a8 8 0 118-8 8 8 0 01-8 8zm0 0'
      />
      <path
        className='prefix__a'
        d='M12.245 17.409a2.034 2.034 0 102.1 2.033 2.069 2.069 0 00-2.1-2.033zm0 2.753a.724.724 0 11.788-.721.757.757 0 01-.788.722zm0 0M15.799 19.439a.656.656 0 00.656.656h8.744a.656.656 0 100-1.312h-8.744a.656.656 0 00-.656.656zm0 0M12.245 11.705a2.034 2.034 0 102.1 2.033 2.069 2.069 0 00-2.1-2.033zm0 2.754a.724.724 0 11.788-.721.757.757 0 01-.788.721zm0 0M12.245 23.11a2.034 2.034 0 102.1 2.033 2.069 2.069 0 00-2.1-2.033zm0 2.753a.724.724 0 11.788-.721.757.757 0 01-.788.721zm0 0M25.198 24.518h-8.744a.656.656 0 100 1.312h8.744a.656.656 0 100-1.312zm0 0'
      />
    </svg>
  )
}

export default SvgComponent
